import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'

/**
 * Hook for setting page title and meta description
 * @param title - Page title (will be appended with site name)
 * @param description - Optional meta description
 * @returns Helmet component for additional head tags
 */
export function usePageTitle(title: string, description?: string) {
  const fullTitle = title ? `${title} - TeamMate` : 'TeamMate - AI Employee Store'
  
  // Force update document title immediately to prevent persistence issues
  useEffect(() => {
    document.title = fullTitle
  }, [fullTitle])
  
  return (
    <Helmet key={fullTitle}>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
    </Helmet>
  )
}

/**
 * Simple hook to set just the page title
 * @param title - Page title
 */